export const texts = [
  "Note that system automatically uses the first column of the data sheet as the column heading on Plug, if no pairing is done.",
  "Warning: you need to create a datasheet to match its headers with the headers gotten from the uploaded csv file",
];
